import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const diffuseCenterManager = (input: { centerId: number }) => {
  const { centerId } = input
  return restApiClient
    .url(constructApiUrl(API.centers.diffuseCenterManager.url, { id: centerId }))
    .post()
}
